import type {HighchartsConfig} from "highcharts-angular";

/** Kept out of `main.ts`, which bootstraps at module scope and so cannot be imported by a test. */
export const HIGHCHARTS_PROVIDER_CONFIG: HighchartsConfig = {
    // Dynamic import: Highcharts + all HC12 modules stay out of the initial bundle.
    // app/highcharts registers modules and calls setOptions() before any chart renders.
    instance: () => import("app/highcharts").then(m => m.default),

    // Must stay explicitly 0: the directive resolves this as `?? 500` and waits it out before
    // constructing any chart, a flat 500ms floor under every chart's first paint.
    timeout : 0
};
